import React from 'react';
import { motion } from 'framer-motion';
import { galleryItems } from '../data/content';
export function Gallery() {
  return <section className="bg-fil-bg px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-65" data-mp="34bolq0w1mitf">
      <div className="max-w-6xl mx-auto" data-id="element-66" data-mp="3icrailefa781">
        <div className="text-center max-w-2xl mx-auto mb-8 sm:mb-12" data-id="element-67" data-mp="3ibg7wowpr5ii">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fil-text leading-tight mb-4" data-id="element-68" data-mp="3de694infphi0">
            Mira todo lo que puedes crear con filigrana de papel
          </h2>
          <p className="text-base sm:text-lg text-fil-taupe" data-id="element-69" data-mp="2koza7ik2ipw8">
            Desde pequeños detalles hasta composiciones llenas de color.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5" data-id="element-70" data-mp="2zf6l9d7qx6mw">
          {galleryItems.map((item, i) => <motion.figure key={item.label} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative rounded-[1.5rem] overflow-hidden aspect-[4/5] bg-fil-card border border-fil-beige" data-id="element-71" data-mp="2uktyouaz3f6x" data-mpi={i}>
              <img src={item.img} alt={`Proyecto de filigrana de papel: ${item.label.toLowerCase()}`} className="w-full h-full object-cover" data-id="element-72" data-mp="11249uj3m5w89" />
              <figcaption className="absolute bottom-3 left-3 bg-white/95 text-fil-cocoa text-[11px] sm:text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-73" data-mp="15369v25cucba">
                {item.label}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}